// extracted by mini-css-extract-plugin
export default {"loadingPlaceholder":"styles_loadingPlaceholder__kQ4xf"};